import React, { useContext, useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import ToastContext from "../Context/toastContext";
import axiosClient from "../Utils/axiosClient";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import DatagridContext from "../Context/datagridContext";
import toolbar from "../Config/toolbarConfig";
import Datagrid from "../Components/Datagrid";
import editSettings from "../Config/editSettingsConfig";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { useTranslation } from "react-i18next";

const CreditsPage = () => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [usersData, setUsersData] = useState([]);
  const [status, setStatus] = useState(null);
  const [selectedUser, setSelectedUser] = useState("");
  const [creditAmount, setCreditAmount] = useState(0);

  const { showToast } = useContext(ToastContext);
  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const currentDate = new Date();

  useTitle(`${t("Credits")} | Netileti`);

  //for the users data
  const fetchUsers = async () => {
    try {
      const response = await axiosClient.get("/Users");

      if (response.status === 200) {
        setUsersData(response.data.result);
      } else {
        setStatus(response.status);
        showToast(
          `${t("Error")}: ${response.statusText}`,
          "Http status :",
          response.status
        );
      }
    } catch (error) {
      setStatus(error.response?.status || 500);
      showToast(
        `${t("Failed to fetch data. Please try again.")}`,
        `${t("Error")}`
      );
    }
  };

  //for the credits data
  const fetchCredits = async () => {
    setUrl(`${baseUrl}/credits`);
    setFrom("Credits");
  };

  useEffect(() => {
    fetchUsers();
    fetchCredits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setStatus(status);
  }, [status]);

  const onUserChange = (event) => {
    const selectedItem = event.itemData;

    setSelectedUser(selectedItem ? selectedItem.id : null);
  };

  const refreshGrid = () => {
    const gridElement = document.getElementById("adaptivebrowser");
    if (gridElement) {
      const grid = gridElement.ej2_instances[0];
      grid.refresh();
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!selectedUser) {
      showToast(`${t("Please select a user")}.`, `${t("Error")}`);
      return;
    }

    if (creditAmount <= 0) {
      showToast(`${t("Please enter valid credit amount")}.`, `${t("Error")}`);
      return;
    }

    const payload = {
      userId: selectedUser,
      creditAmount,
      timestamp: Math.floor(currentDate.getTime() / 1000).toString(),
    };

    try {
      const response = await axiosClient.post("/credits", payload);

      if (response.status === 200) {
        refreshGrid();
        showToast(
          `${t("Credit")} ${t("Added successfully!")}`,
          `${t("Success")}`
        );
        setSelectedUser(null);
        setCreditAmount(0);
      } else {
        showToast(
          `${t("Error")}: ${response.statusText}, ${t("Status Code")}: ${
            response.status
          }`,
          `${t("Error")}`
        );
      }
    } catch (error) {
      showToast(`${t("Failed to add")} : ${error.message}`, `${t("Error")}`);
    }
  };

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "userId",
      headerText: "userId",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "userName",
      headerText: t("User Name"),
      allowEditing: false,
    },
    {
      field: "creditAmount",
      headerText: t("Credit"),
      allowEditing: true,
    },
    {
      field: "timestamp",
      headerText: t("Time"),
      allowEditing: false,
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      <div className="credits">
        <div className="add-credit">
          <form id="add-credit-form" onSubmit={onSubmit}>
            <ComboBoxComponent
              placeholder={t("User Name")}
              dataSource={usersData}
              fields={{ text: "userName", value: "id" }}
              value={selectedUser}
              change={onUserChange}
              required
              autofill={true}
              allowCustom={false}
            />
            <input
              id="credit-amount"
              className="e-input"
              type="number"
              placeholder={t("Credit Amount")}
              value={creditAmount}
              onChange={(e) => setCreditAmount(e.target.value)}
              required
            />
            <ButtonComponent cssClass="e-primary e-outline" type="submit">
              {t("Add Credit")}
            </ButtonComponent>
          </form>
        </div>
        <hr />
        <div className="credit-grid">
          {status === 401 ? (
            <UnauthorizePage />
          ) : status === 403 ? (
            <ForbiddenPage />
          ) : (
            <DatagridContext.Provider
              value={{
                // data,
                toolbar: toolbar("RUD-EXPORT"),
                editSettings,
                url,
                from,
                setStatus,
              }}
            >
              <Datagrid columns={columns} />
            </DatagridContext.Provider>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditsPage;
